var React = require('react');

function VideoButtonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 12.8831L0.175361 24.9062L0.175362 0.859982L21 12.8831Z","fill":"#FFFFFF"}));
}

VideoButtonIcon.defaultProps = {"width":"21","height":"25","viewBox":"0 0 21 25","fill":"none"};

module.exports = VideoButtonIcon;

VideoButtonIcon.default = VideoButtonIcon;
